import axios from 'axios';

export const serverAddress = 'https://api.coeupdspadelhi.in/api';

export const GET_ALL_KR_LIST = async () => {
    const url = `${serverAddress}/repository-list-webiste`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_COLLABORATION_LIST = async () => {
    const url = `${serverAddress}/collaborations-list-webiste`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_RESEARCH_LIST = async () => {
    const url = `${serverAddress}/research-list-webiste`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_ONGOING_PROJECT_LIST = async () => {
    const url = `${serverAddress}/projects-list-website`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_UPCOMING_PROJECT_LIST = async () => {
    const url = `${serverAddress}/projects-upcoming-list-website`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_TEAM_MEMBERS_LIST = async (data) => {
    const url = `${serverAddress}/team-members-list-webiste/${data}`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_EVENTS_LIST = async (data) => {
    const url = `${serverAddress}/events-list-webiste`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_ANNOUNCEMENTS_LIST = async (data) => {
    const url = `${serverAddress}/announcement-list-webiste`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_VACANCIES_LIST = async (data) => {
    const url = `${serverAddress}/vacancies-list-webiste`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_BANNERS_LIST = async (data) => {
    const url = `${serverAddress}/banner-list-webiste`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};
